import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/seo/`,
    detail: (id) => `${BASE_URL}/api/v1/seo/${id}/`,
};

export const pageLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const pageDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const pageUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const pageDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
